export default {
  nav: {
    findBarber: 'Finde einen Barber'
  },
  navigation: {
    home: 'Startseite',
    aboutUs: 'Über uns',
    contactUs: 'Kontakt',
    demo: 'Demo',
    login: 'Login',
    language: 'Sprache',
    logo: 'Logo',
    toggleMenu: 'Menü umschalten',
    changeLanguage: 'Sprache ändern',
    scrollToTop: 'Nach oben scrollen',
    joinAsBarber: 'Als Barber registrieren',
    pricing: 'Preise',
    signUp: 'Registrieren / Anmelden'
  },
  home: {
    hero: {
      eyebrow: 'Onboarding jetzt in Sofia – nur noch 3 Plätze diese Woche',
      mainTitle: 'Dein Stuhl.<br>Dein Kalender.<br><span class="hero-title-accent">Dein Wachstum.</span>',
      mainDesc: "Du hast Jahre damit verbracht, dein Handwerk zu meistern. Du solltest deine Abende nicht damit verbringen, WhatsApp-Nachrichten zu beantworten. Barbers Unity gibt dir eine professionelle Buchungsseite und einen vollständigen Kalender – damit du dich aufs Schneiden konzentrieren kannst, statt Kunden hinterherzurennen.",
      growBusiness: 'Ich will mehr Kunden',
      seeDashboard: 'Zum Dashboard',
      trustText: '<strong>Petar Barbov</strong> und Barber aus ganz Europa sind bereits auf der Plattform.',
      joinThem: 'Schließ dich ihnen an →'
    },
    pain: {
      label: 'Kommt dir das bekannt vor?',
      answer: 'Barbers Unity kümmert sich um all das.',
      items: [
        'Kunden rufen an, genau wenn du mitten im Schnitt bist',
        'No-Shows, die deine besten Termine blockieren',
        'Du vergisst, WhatsApp-Termine zu bestätigen',
        'Doppelbuchungen, die für peinliche Momente sorgen',
        'Du nutzt 2025 immer noch ein Terminbuch aus Papier'
      ]
    },
    mobile: {
      label: 'Management für die Hosentasche',
      title: 'Manage deinen Barbershop von überall.',
      desc: "Du arbeitest nicht am Schreibtisch. Barbers Unity ist komplett für dein Smartphone optimiert. Check deinen Kalender, nimm Termine an und sieh dir die Kundenhistorie zwischen den Schnitten an.",
      list: [
        'Sofortige Push-Benachrichtigungen bei neuen Buchungen',
        'Die komplette Kundenhistorie auf einen Blick',
        'Trage Laufkunden (Walk-ins) in nur 3 Sekunden in den Kalender ein'
      ]
    },
    featuresList: [
      { title: 'Deine eigene Buchungsseite', desc: 'Ein professioneller Link, den du überall teilen kannst – Instagram-Bio, WhatsApp, Google. Kunden buchen selbst, 24/7.' },
      { title: 'Smarter Kalender', desc: 'Deine ganze Woche auf einen Blick. Blockiere private Zeiten, lege Arbeitszeiten fest und vermeide Doppelbuchungen für immer.' },
      { title: 'Kundendatenbank', desc: "Historie und Kontaktdaten jedes Kunden – übersichtlich, durchsuchbar und immer griffbereit." },
      { title: 'Internationale Plattform', desc: 'Entwickelt für Barber in ganz Europa. Unterstützt EN, BG, HR, ALB, GER und wächst stetig.' }
    ],
    calendar_preview: {
      title: 'Dein Kalender, auf jedem Gerät.'
    },
    how: {
      label: 'So legst du los',
      title: 'In unter 10 Minuten startklar'
    },
    stepsList: [
      { title: 'Erstelle dein Profil', desc: 'Registriere dich in wenigen Minuten. Füge deine Dienstleistungen hinzu, lege deine Arbeitszeiten fest und erhalte sofort deinen professionellen Buchungslink. Keine technischen Kenntnisse erforderlich.' },
      { title: 'Teile deinen Buchungslink', desc: 'Pack ihn in deine Instagram-Bio, deinen WhatsApp-Status oder schick ihn deinen Stammkunden. Sie buchen in Sekunden.' },
      { title: 'Einfach zur Arbeit kommen und schneiden', desc: 'Der Kalender führt sich von selbst. Du konzentrierst dich einfach aufs Haareschneiden und darauf, dir einen Namen zu machen.' }
    ],
    trust: {
      card1: { title: 'Wir übernehmen die harte Arbeit', desc: "Angst vor dem Systemwechsel? Keine Sorge. Schick uns deine Kundenliste (Excel, Booksy-Export oder Fotos deines alten Terminbuchs) und wir importieren deine Kunden und erstellen dein Profil völlig kostenlos." },
      card2: { title: '100% Datenkontrolle', desc: 'Andere Plattformen nutzen deine Kunden, um konkurrierende Barber zu bewerben. Bei Barbers Unity gehört deine Kundenliste nur dir. Wir verkaufen deine Daten niemals und schicken deinen Kunden keine Werbung.' }
    },
    testimonial: {
      quote: "Vor Barbers Unity habe ich jede Woche 3-4 Termine verloren, nur durch verpasste Anrufe und WhatsApp-Nachrichten, auf die ich vergessen habe zu antworten. Bei 20 € pro Schnitt sind das 240-320 €, die mir jeden Monat durch die Lappen gingen. Jetzt füllt sich mein Kalender von selbst. Ich komme einfach zur Arbeit und schneide.",
      name: 'Petar Barbov',
      role: 'Professioneller Barber · Mitglied der ersten Stunde'
    },
    stats: {
      label: 'Aktivität auf der Plattform',
      title: 'Echte Zahlen, die jeden Tag wachsen',
      bookings: 'Verwaltete Buchungen',
      clients: 'Bediente Kunden',
      time: 'Ersparte Admin-Zeit pro Barber / Woche'
    },
    pricing: {
      label: 'Faire Preise',
      title: "Zahl keine Provisionen auf deinen eigenen Erfolg",
      desc: 'Andere Plattformen bestrafen dich dafür, dass du mehr zu tun hast, indem sie pro Buchung kassieren. Wir glauben: Was du verdienst, gehört dir.',
      competitorNote: 'Sobald sich ein konkurrierender Barber in deiner Stadt anmeldet, hat er einen Vorteil. Der erste Barber in einer Region erhält bei der Kundensuche eine bevorzugte Platzierung.',
      identityLine: 'Entwickelt für Barber, die das hier als Business behandeln, nicht als Hobby.',
      them: {
        label: 'Die Konkurrenz',
        list: [ 'Gebühr pro Buchung', 'Versteckte Gebühren und unerwartete Kosten', 'Die Kosten steigen, wenn du mehr zu tun hast' ],
        price: 'Bis zu 200 €',
        sub: '/Monat'
      },
      vs: 'VS',
      us: {
        label: 'Barbers Unity',
        list: [ 'Unbegrenzte Buchungen', 'Null Provisionen, keine versteckten Gebühren', 'Behalte 100% deiner Einnahmen' ],
        price: '35 €',
        sub: '/Monat pauschal'
      }
    },
    calc: {
      label: 'Umsatzrechner',
      title: "Sieh selbst, wie viel du verlierst",
      desc: 'Jeder verpasste Termin bedeutet weniger Geld. Bewege die Regler, um zu sehen, wie viel du jeden Monat mehr verdienen könntest.',
      button: 'Fange an, mehr zu verdienen',
      cuts: 'Schnitte pro Tag',
      price: 'Preis pro Schnitt (€)',
      missed: 'Verpasste Termine pro Woche',
      monthlyNow: 'Dein Monatsumsatz jetzt',
      withUs: 'Mit Barbers Unity',
      recovered: '/ Monat zurückgewonnen',
      lossThisMonth: 'diesen Monat bereits verloren'
    },
    faq: {
      label: 'Noch Fragen?',
      title: 'Häufig gestellte Fragen'
    },
    faqList: [
      { q: "Müssen meine Kunden eine App herunterladen?", a: "Nein! Deine Kunden buchen über einen sauberen, schnellen Link direkt im Browser. Keine App-Downloads, keine Account-Pflicht und null Aufwand für sie." },
      { q: "Wie werde ich bezahlt?", a: "Du behältst 100% von dem, was du verdienst. Deine Kunden bezahlen dich wie immer direkt im Shop. Wir nehmen keinen Cent Provision für deine Schnitte." },
      { q: "Bin ich an einen Vertrag gebunden?", a: "Absolut nicht. Barbers Unity ist ein monatlich kündbares Abo. Du kannst jederzeit kündigen." },
      { q: "Ich nutze bereits ein anderes System. Ist ein Wechsel schwer?", a: "Es kostet dich 0 Aufwand. Schick uns deine aktuelle Kundenliste und wir importieren alles und erstellen dein Profil für dich – komplett kostenlos." }
    ],
    upcoming: {
      label: 'Demnächst',
      title: 'Noch stärkere Tools sind auf dem Weg',
      badge: 'Bald'
    },
    upcomingList: [
      { title: 'Automatische Erinnerungen', desc: 'E-Mail- und WhatsApp-Erinnerungen werden vor jedem Termin verschickt – No-Shows gehören damit der Vergangenheit an.' },
      { title: 'Analytics & Umsatzübersicht', desc: 'Sieh dir deine besten Services, die am stärksten gebuchten Zeiten und deine Top-Kunden an – triff schlauere Entscheidungen für dein Business.' },
      { title: 'Treuesystem', desc: 'Belohne Stammkunden, tracke ihre Besuche und sorge mit unserem integrierten System dafür, dass sie immer wieder kommen.' }
    ],
    cta: {
      eyebrow: 'Begrenzte Plätze – sichere dir deinen, bevor sie weg sind',
      title: 'Bereit für einen vollen Kalender?',
      sub: 'Schließ dich den Barbern an, die ihr Business selbst steuern – und nicht umgekehrt.',
      microYes: [
        'Ich will jede Woche einen ausgebuchten Kalender',
        'Ich will null No-Shows',
        'Ich will nicht mehr den Rezeptionisten spielen'
      ],
      findBarber: 'Finde einen Barber in deiner Nähe',
      member: 'Schon Mitglied?',
      login: 'Logge dich in dein Dashboard ein →'
    },
    pricingCta: {
      title: 'Bereit, deinen Barbershop zu vergrößern?',
      subtitle: '35 €/Monat · Erster Monat kostenlos',
      button: 'Jetzt starten'
    }
  },
  about: {
    title: 'Über Barbers Unity',
    description: "Wir verändern von Grund auf, wie Barber mit ihren Kunden in Kontakt treten. Unsere Plattform hilft Barbern, ihre Arbeit zu präsentieren, ihre Termine zu verwalten und ihr Geschäft effizient auszubauen.",
    founded: 'Gegründet im Jahr 2025, ist Barbers Unity von einer einfachen Idee zu einer umfassenden Plattform herangewachsen, die Barbern in mehreren Ländern dient.',
    ourStory: 'Unsere Geschichte',
    whatDrivesUs: 'Was uns antreibt',
    mission: {
      title: 'Unsere Mission',
      description: 'Den Buchungsprozess für Barber zu vereinfachen und zu modernisieren'
    },
    vision: {
      title: 'Unsere Vision',
      description: 'Die weltweit größte Community vernetzter Barber aufzubauen'
    },
    values: {
      title: 'Unsere Werte',
      description: 'Qualität, Vertrauen und professionelles Wachstum'
    },
    built: {
      label: 'Aus der Praxis, für die Praxis',
      title: 'Wir wissen, wie es hinterm Stuhl ist.',
      desc1: "Barbers Unity wurde nicht in irgendwelchen Büros entwickelt. Es entstand, weil wir gesehen haben, wie großartige Barber – talentiert, gefragt, respektiert – Kunden an unbeantwortete Anrufe und schlechte, nicht für sie gemachte Buchungssysteme verloren haben.",
      desc2: 'Wir haben die Plattform gebaut, die wir uns selbst gewünscht hätten: eine, die dein Handwerk ernst nimmt, deinen Namen in den Vordergrund stellt und dir die Admin-Arbeit abnimmt, damit du dir darüber keine Gedanken mehr machen musst.',
      stats: {
        countries: 'Länder, in denen wir aktiv sind',
        time: 'Bis zum Start',
        cost: 'Setup-Kosten'
      }
    },
    testimonial: {
      quote: "Vor Barbers Unity habe ich jede Woche 3-4 Termine verloren, nur durch verpasste Anrufe und WhatsApp-Nachrichten, auf die ich vergessen habe zu antworten. Bei 20 € pro Schnitt sind das 240-320 €, die mir jeden Monat durch die Lappen gingen. Jetzt füllt sich mein Kalender von selbst. Ich komme einfach zur Arbeit und schneide.",
      name: 'Petar Barbov',
      role: 'Professioneller Barber · Mitglied der ersten Stunde'
    },
    timeline: {
      label: 'Zeitstrahl',
      title: 'Wir bauen etwas Größeres.',
      items: [
        { year: '2025', event: 'Barbers Unity wird gegründet – eine Idee, geboren aus dem Frust über endlos klingelnde Telefone und verpasste Termine.' },
        { year: '2025', event: 'Die Plattform startet in die Beta-Phase.' },
        { year: 'Jetzt', event: 'Das Netzwerk wächst – mehr Barber, mehr Städte, bessere Tools für alle.' }
      ]
    },
    cta: {
      eyebrow: 'Begrenzte Plätze – sichere dir deinen, bevor sie weg sind',
      title: 'Willst du Teil der Geschichte werden?',
      description: "Egal, ob du Barber oder Kunde bist, in der Barbers Unity Community ist immer Platz für dich.",
      findBarber: 'Finde einen Barber',
      getInTouch: 'Kontaktiere uns'
    }
  },
  contact: {
    title: 'Kontakt',
    getInTouch: {
      title: 'Kontaktiere uns',
      description: 'Hast du Fragen zu Barbers Unity? Wir sind hier, um zu helfen! Schreib uns auf unseren Social-Media-Kanälen oder sende uns direkt eine Nachricht.',
      info: "Hast du Fragen zu Barbers Unity? Wir sind hier, um zu helfen – schreib uns über einen der unten stehenden Kanäle."
    },
    followUs: 'Folge uns',
    b2b: {
      text: "<strong>Bist du ein Barber?</strong> Überspring das Formular – buche einen kostenlosen 20-minütigen Call und wir richten alles gemeinsam ein.",
      button: 'Kostenlosen Call buchen'
    },
    success: {
      title: 'Nachricht gesendet!',
      desc: "Danke für deine Nachricht. Wir werden uns so schnell wie möglich bei dir melden.",
      button: 'Weitere senden'
    },
    form: {
      name: 'Name',
      namePlaceholder: 'Dein Name',
      email: 'E-Mail',
      emailPlaceholder: 'deine@email.com',
      message: 'Nachricht',
      messagePlaceholder: 'Sag uns, wie wir helfen können...',
      send: 'Nachricht senden'
    }
  },
  forBusiness: {
    hero: {
      eyebrow: 'Begrenzte Plätze – wir nehmen jetzt neue Barber auf',
      mainTitle: 'Manage dein Business nicht länger<br><span class="title-accent">per Hand.</span>',
      mainDesc: 'Jeder verpasste Anruf ist Geld, das dir durch die Finger rinnt. Jeder No-Show blockiert einen wertvollen Termin. Barbers Unity bietet dir ein professionelles System, das deinen Kalender füllt und deine Kunden informiert hält.',
      bookCall: 'Kostenlosen Setup-Call buchen',
      seeDashboard: 'Zum Dashboard',
      trust: ['Kostenloses Setup', 'Keine Verträge', 'In 10 Minuten startklar']
    },
    loss: {
      beforeLabel: 'Ohne Barbers Unity',
      afterLabel: 'Mit Barbers Unity',
      without: [
        'Anrufe verpassen, während du schneidest',
        'No-Shows, die leere Termine hinterlassen',
        'Jede Buchung manuell bestätigen',
        'Chaotische Terminbücher oder Excel-Listen',
        'Nicht wissen, welche Services den meisten Profit bringen'
      ],
      with: [
        'Kunden buchen selbst online, 24/7',
        'Kalender aktualisiert sich sofort, ohne Aufwand',
        'Professionelles Dashboard, immer aufgeräumt',
        'Komplette Buchungshistorie und Service-Auswertungen',
        'Funktioniert in mehreren Ländern und Sprachen'
      ]
    },
    features: {
      label: 'Was du bekommst',
      heading: 'Alles, was ein professioneller Barber braucht',
      items: [
        { title: 'Deine professionelle Buchungsseite', desc: 'Ein sauberer Link mit deinem Namen, den du überall teilen kannst – Instagram-Bio, WhatsApp, Google. Kunden sehen Services, Preise, freie Termine und buchen selbst. Keine Anrufe, kein endloses Hin und Her.', badge: 'In Minuten startklar' },
        { title: 'Ein kompletter Kalender nur für Barber', desc: 'Blockiere deine Pausenzeiten, leg deine Arbeitszeiten fest, verwalte verschiedene Services mit unterschiedlicher Dauer. Sieh deine ganze Woche auf einen Blick und vermeide Doppelbuchungen.', badge: null },
        { title: 'Kundenhistorie und Vorlieben', desc: "Historie der Schnitte, Kontaktdaten und Notizen für jeden Kunden – alles übersichtlich. Weiß genau, was der Kunde will, noch bevor er auf dem Stuhl sitzt.", badge: null },
        { title: 'Automatische Erinnerungen (demnächst)', desc: 'Erinnerungsnachrichten per E-Mail und WhatsApp werden vor jedem Termin automatisch verschickt. No-Shows gehören damit der Vergangenheit an. Startet in Kürze.', badge: 'Bald' }
      ]
    },
    why: {
      label: 'Warum sich Barber für uns entscheiden',
      heading: 'Dein Stuhl.<br>Deine Regeln.<br>Dein Profit.',
      body: 'Barbers Unity bringt dein Business vor Kunden, die aktiv nach einem Barber suchen – ohne dass du sie fragen, ihnen hinterherrennen oder dich stressen musst.',
      list: [
        'Null Kundenakquise – die Kunden kommen zu dir',
        'In einem 20-minütigen Call eingerichtet, komplett kostenlos',
        'Funktioniert perfekt mit deinem aktuellen WhatsApp und E-Mail',
        "Keine Verträge – geh, wann du willst (aber du wirst keinen Grund dazu haben)",
        'Persönlicher Support von echten Menschen, keine Chatbots'
      ],
      highlights: [
        { title: 'Sofortiges Setup', desc: "Ein 20-minütiger Call. Du bist startklar, bevor du auflegst." },
        { title: 'Für Barber gemacht', desc: 'Gemeinsam mit Barbern entwickelt – nicht nur für sie.' },
        { title: 'Mehrsprachig', desc: 'EN, BG, HR, ALB, GER – wo auch immer du arbeitest.' },
        { title: 'Keine Verträge', desc: 'Starte kostenlos. Bleib, weil es funktioniert, nicht weil du musst.' }
      ]
    },
    testimonial: {
      quote: "Vor Barbers Unity habe ich jede Woche 3-4 Termine verloren, nur durch verpasste Anrufe und WhatsApp-Nachrichten, auf die ich vergessen habe zu antworten. Bei 20 € pro Schnitt sind das 240-320 €, die mir jeden Monat durch die Lappen gingen. Jetzt füllt sich mein Kalender von selbst. Ich komme einfach zur Arbeit und schneide.",
      name: 'Petar Barbov',
      role: 'Professioneller Barber · Mitglied der ersten Stunde'
    },
    cta: {
      eyebrow: 'Onboarding jetzt in Sofia – nur noch 3 Plätze diese Woche',
      mainTitle: 'Bereit für einen komplett ausgebuchten Kalender?',
      sub: "Buche einen kostenlosen 20-minütigen Call. Wir richten alles gemeinsam ein – dein Profil, deine Services und deinen Kalender. Du bist startklar, bevor das Gespräch endet.",
      bookCall: 'Jetzt kostenlosen Call buchen',
      member: 'Schon Mitglied?',
      login: 'Logge dich in dein Dashboard ein →'
    }
  },
  footer: {
    description: 'Wir verbinden Barber mit ihren Kunden, vereinfachen Buchungen und lassen Unternehmen wachsen.',
    quickLinks: {
      title: 'Quick Links',
      about: 'Über uns',
      contact: 'Kontakt',
      demo: 'Demo'
    },
    legal: {
      title: 'Rechtliches',
      privacy: 'Datenschutzerklärung',
      terms: 'Nutzungsbedingungen'
    },
    followUs: 'Folge uns',
    social: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      tiktok: 'TikTok'
    },
    copyright: '© 2025 BarbersUnity. Alle Rechte vorbehalten.'
  },
  tailwindMessage: "Tailwind CSS funktioniert in Vue 3! 🎉",
  clickMe: "Hier klicken",
  previous: 'Zurück',
  notFound: {
    title: 'Seite nicht gefunden',
    description: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    backHome: 'Zurück zur Startseite'
  },
  cookies: {
    title: 'Cookie-Einstellungen',
    message: 'Wir verwenden Cookies, um deine Erfahrung zu verbessern, den Website-Traffic zu analysieren und personalisierte Inhalte bereitzustellen. Indem du unsere Website weiterhin nutzt, stimmst du der Verwendung von Cookies zu.',
    decline: 'Ablehnen',
    accept: 'Alle akzeptieren'
  },
  map: {
    eyebrow: 'Finde einen Barber',
    heading: 'Barber in deiner Nähe',
    searchPlaceholder: 'Suche nach Stadt oder Barber-Name...',
    loading: 'Karte wird geladen...',
    error: {
      title: 'Karte konnte nicht geladen werden',
      desc: 'Es gab ein Problem beim Laden der Karte. Bitte versuche es erneut.',
      retry: 'Erneut versuchen'
    },
    results: 'Ergebnisse',
    result: 'Ergebnis',
    bookNow: 'Jetzt buchen'
  },
  privacy: {
    intro: 'Willkommen bei Barbers Unity. Wir respektieren deine Privatsphäre und verpflichten uns, deine persönlichen Daten zu schützen. Diese Datenschutzerklärung informiert dich darüber, wie wir mit deinen Daten umgehen, wenn du unsere Website besuchst, über deine Datenschutzrechte und darüber, wie das Gesetz dich schützt.',
    sections: {
      collect: {
        title: '1. Informationen, die wir sammeln',
        desc: 'Wir können verschiedene Arten von personenbezogenen Daten über dich sammeln, verwenden, speichern und übertragen, die wir wie folgt zusammengefasst haben:',
        items: [
          '<strong>Identitätsdaten</strong> umfassen Vorname, Nachname, Benutzername oder ähnliche Identifikatoren.',
          '<strong>Kontaktdaten</strong> umfassen E-Mail-Adresse und Telefonnummern.',
          '<strong>Technische Daten</strong> umfassen Internetprotokoll-(IP)-Adresse, Browsertyp und -version, Zeitzone und andere Technologien auf den Geräten, die du verwendest, um auf diese Website zuzugreifen.'
        ]
      },
      use: {
        title: '2. Wie wir deine Daten verwenden',
        desc: 'Wir werden deine personenbezogenen Daten nur verwenden, wenn das Gesetz es uns erlaubt. Am häufigsten verwenden wir deine Daten unter folgenden Umständen:',
        items: [
          'Wenn wir den Vertrag erfüllen müssen, den wir mit dir abschließen oder abgeschlossen haben (z. B. die Buchung eines Termins).',
          'Wenn es für unsere berechtigten Interessen erforderlich ist und deine Interessen oder Grundrechte diese Interessen nicht überwiegen.',
          'Wenn wir einer gesetzlichen Verpflichtung nachkommen müssen.'
        ]
      },
      contact: {
        title: '3. Kontaktiere uns',
        desc: 'Wenn du Fragen zu dieser Datenschutzerklärung oder unseren Praktiken hast, schreibe uns bitte über unsere Kontaktkanäle.'
      }
    }
  },
  pricing: {
    title: 'Einfache Preise',
    subtitle: 'Ein Plan. Alles inklusive. Erster Monat kostenlos.',
    price: '35',
    period: '/Monat',
    trial: 'Erster Monat KOSTENLOS',
    cta: 'Kostenlose Testversion starten',
    features: [
      'Unbegrenzte Buchungen',
      'Kundenbenachrichtigungen',
      'QR-Code & Story-Generator',
      'Multi-Mitarbeiter-Kalender',
      'Analytics-Dashboard',
      'Priorisierter Support'
    ]
  },
  terms: {
    title: 'Nutzungsbedingungen',
    intro: 'Willkommen bei Barbers Unity. Durch die Nutzung unserer Plattform stimmen Sie diesen Bedingungen zu. Bitte lesen Sie diese sorgfältig durch.',
    sections: {
      account: {
        title: '1. Kontoregistrierung',
        desc: 'Sie müssen bei der Kontoerstellung genaue Angaben machen. Sie sind für die Sicherheit Ihrer Anmeldedaten verantwortlich.'
      },
      usage: {
        title: '2. Zulässige Nutzung',
        desc: 'Sie stimmen zu, die Plattform nicht zu missbrauchen, ihren normalen Betrieb nicht zu stören und nicht zu versuchen, über eine andere als die von uns bereitgestellte Schnittstelle darauf zuzugreifen.'
      },
      fees: {
        title: '3. Abonnement und Gebühren',
        desc: 'Unsere Dienstleistungen werden im Rahmen eines Abonnements abgerechnet. Alle Gebühren sind nicht erstattungsfähig, sofern das Gesetz nichts anderes vorschreibt.'
      },
      liability: {
        title: '4. Haftungsbeschränkung',
        desc: 'Barbers Unity wird "wie besehen" bereitgestellt. Wir haften nicht für indirekte, zufällige oder Folgeschäden, die sich aus Ihrer Nutzung der Plattform ergeben.'
      }
    }
  },
  loading: {
    title: 'Laden...',
    message: 'Bitte warten'
  },
  modal: {
    registerTitle: 'Kontotyp wählen',
    businessTitle: 'Als Unternehmen registrieren',
    businessDesc: 'Salon / Barber',
    customerTitle: 'Als Kunde registrieren',
    customerDesc: 'Termine buchen'
  }
}